import React, { useState, forwardRef, useEffect } from "react";

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Container from "@mui/material/Container";

import DataTable from "../components/dataTable/DataTable";
import Analysis from "./analysis/Analysis";

import AddNewSheet from "./dataTable/features/AddNewSheet";
import { useParams } from "react-router-dom";
import { getDocumentData } from "../utils/variables";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DataTableAndAnalytics = () => {
  // states
  // const { lastAutosaveDate } = useSelector(
  //   (state) => state.dataTable
  // );

  // const dispatch = useDispatch();
  const { documentId } = useParams();
  const [isEnlarged, setIsEnlarged] = useState(false);
  const [sheetArray, setSheetArray] = useState([{ page: 1, id: documentId }]);
  const [selectedSheet, setSelectedSheet] = useState(1);

  // functions
  const handleViewChange = () => {
    setIsEnlarged((isEnlarged) => !isEnlarged);
  };

  useEffect(() => {
    const getData = async () => {
      const docData = await getDocumentData(documentId);
      docData && setSheetArray(docData);
    };

    getData();
  }, [documentId]);

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <DataTable
            action={handleViewChange}
            title="Enlarge view"
            sheetArray={sheetArray}
            setSheetArray={setSheetArray}
            selectedSheet={selectedSheet}
            setSelectedSheet={setSelectedSheet}
          />
          <Dialog
            fullScreen
            open={isEnlarged}
            onClose={handleViewChange}
            TransitionComponent={Transition}
          >
            <Container
              style={{
                padding: "20px",
                height: "100%",
              }}
            >
              <DataTable action={handleViewChange} title="Minimize view" />
            </Container>
          </Dialog>
          <AddNewSheet
            sheetArray={sheetArray}
            setSheetArray={setSheetArray}
            selectedSheet={selectedSheet}
            setSelectedSheet={setSelectedSheet}
          />
        </Grid>

        <Grid item xs={12} md={5.8} style={{ marginLeft: "1.5%" }}>
          <Analysis />
        </Grid>
      </Grid>
    </>
  );
};

export default DataTableAndAnalytics;
